import $ from 'jquery';
import { onPageLoad } from '@/js/modules/page_load';

onPageLoad(() => {
  $(document).on('input', '.growable-field-container__field', (e) => {
    e.target.parentElement.dataset.replicatedValue = e.target.value;
  });
});
